module.exports = __webpack_public_path__ + "static/media/DSC04762.92ec1aff.JPG";